import Heading from "@unum/heading";
import classnames from "classnames";
import React, { useMemo } from "react";
import styles from "./Hero.module.scss";
import { HomepageProps } from "./types";

const Homepage = ({ title, subtitle, asset, cta }: HomepageProps) => {
  const assetNode = useMemo(() => {
    if (!React.isValidElement<{ className: string }>(asset)) {
      return asset;
    }
    return React.cloneElement(asset, {
      className: classnames(asset.props.className)
    });
  }, [asset]);

  return (
    <div className={`spring ${styles["Hero"]} ${styles["Hero--homepage"]}`}>
      <div className={styles["overlap-container"]}>
        <div className={styles["information-wrapper"]}>
          <div className={styles["information"]}>
            <Heading level={1} className={styles["heading"]}>
              <div className={styles["title-wrapper"]}>{title}</div>
              <div className={styles["subtitle-wrapper"]}>{subtitle}</div>
            </Heading>
            {cta}
          </div>
        </div>
        <div
          className={classnames(styles["image-wrapper"], "hero__image-wrapper")}
        >
          {assetNode}
        </div>
      </div>
    </div>
  );
};

export default Homepage;
